import { ref, type Ref } from 'vue';

const states = new Map<string, Ref<boolean>>();

function ensure(id: string): Ref<boolean> | null {
  if (typeof id !== 'string' || !id) return null;
  if (!states.has(id)) states.set(id, ref(false));
  return states.get(id) as Ref<boolean>;
}

export function useCollapse() {
  const registerCollapse = (id: string): boolean => {
    const result = !!ensure(id);
    return result;
  };

  const toggleCollapseState = (id: string): void => {
    const stateRef = ensure(id);
    if (!stateRef) return;
    stateRef.value = !stateRef.value;
  };

  const getCollapseState = (id: string): Ref<boolean> | null => {
    return ensure(id);
  };

  return {
    registerCollapse,
    toggleCollapseState,
    getCollapseState,
  };
}
